import { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { ENGINE_MMI_2026, ENGINE_MMI_2026_CORRECTED, engineOf, type MmiEngine } from './engine';
import { ENGINE_LABELS } from './labels';
import { Field } from './Field';

const ENGINES: readonly MmiEngine[] = [ENGINE_MMI_2026, ENGINE_MMI_2026_CORRECTED];
const STORAGE_KEY = 'simulateur.engine';

/** Moteur choisi, mémorisé dans le navigateur : il survit au rechargement et au changement d'onglet. */
export function useStoredEngine(): [MmiEngine, (engine: MmiEngine) => void] {
  const [engine, setEngine] = useState<MmiEngine>(() => {
    try {
      return engineOf(localStorage.getItem(STORAGE_KEY) ?? '');
    } catch {
      return ENGINE_MMI_2026;
    }
  });
  const update = (next: MmiEngine) => {
    setEngine(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      // stockage indisponible : le choix vaut pour cette page seulement
    }
  };
  return [engine, update];
}

export function EngineSelect({ value, onChange }: { value: MmiEngine; onChange: (engine: MmiEngine) => void }) {
  return (
    <Field label="Moteur de calcul" htmlFor="engine">
      <Select value={value} onValueChange={(next) => onChange(engineOf(next))}>
        <SelectTrigger className="w-full max-w-md" id="engine">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {ENGINES.map((engine) => (
            <SelectItem key={engine} value={engine}>
              {ENGINE_LABELS[engine]}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Field>
  );
}
